import { IFilterOptions } from "../useAssetTree";
import OptionsTreeWithUngrouped, { IOptionsTreeConfig } from "./sharedTree";

interface ISegmentTree {
  filterOptions: IFilterOptions;
  selectedSegments: string[];
  setSelectedSegments: (items: string[]) => void;
  includeNullSegment: boolean;
  setIncludeNullSegment: (value: boolean) => void;
}

const SEGMENT_TREE_CONFIG: IOptionsTreeConfig = {
  groupId: "segments",
  ungroupedGroupId: "segments-desagrupado",
  ungroupedItemId: "__desagrupado_segment__",
  itemType: "role-management",
  icon: "rioglyph rioglyph-role-management",
  groupLabel: "assetTree.segment.group",
  ungroupedItemLabel: "assetTree.segment.noItem",
  searchPlaceholder: "assetTree.segment.search",
};

const SegmentTree = ({
  filterOptions,
  selectedSegments,
  setSelectedSegments,
  includeNullSegment,
  setIncludeNullSegment,
}: ISegmentTree) => (
  <OptionsTreeWithUngrouped
    config={SEGMENT_TREE_CONFIG}
    options={filterOptions?.segments}
    selectedIds={selectedSegments}
    setSelectedIds={setSelectedSegments}
    includeNull={includeNullSegment}
    setIncludeNull={setIncludeNullSegment}
  />
);

export default SegmentTree;
